/**
 * The traced edge GET of a browser flow client that resolves its OWN bearer (a bridge read, the local SDK): the token
 * rides as the Authorization header over {@link fetchTracedEdge}. The chats viewer, the title-report view and the
 * property page's title probes each spelled the same bearer-only request init, now `bearerRequestInit`.
 *
 * A SEPARATE LEAF from `traced-edge-fetch.ts` on purpose: that leaf decides no credential at all, and a suite that
 * stubs its transport still sees the header this one composes.
 */

import { bearerRequestInit } from '@federa/const/http-bearer-auth';
import { fetchTracedEdge } from '@federa/components/lib/api/traced-edge-fetch';

/** GET `url` over the traced edge transport with `token` as the bearer; a missing token sends no Authorization header. */
export function fetchTracedEdgeAsBearer(url: string, token: string | null | undefined, signal?: AbortSignal): Promise<Response> {
	return fetchTracedEdge(url, bearerRequestInit(token), signal);
}
